export default __webpack_public_path__ + "static/media/JejuMyeongjo.4e4f1e5a.woff2";